"use client"

import { useState, useEffect } from "react"
import { BrowserRouter as Router, useLocation } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import AppRoutes from "./routes/AppRoutes"
import NavBar from "./components/NavBar/NavBar"
import { ToastContainer } from "react-toastify"
import { AuthProvider } from "./utils/AuthContext"
import AnimatedIntro from "./components/Animation/AnimationWrapper"
import "./App.css"
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary"
import Footer from "./components/Footer/Footer"
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton"
import { LocationProvider } from "./utils/LocationContext"
import { CategoriesProvider } from "./utils/CategoriesContext"
import { NotificationProvider } from "./utils/NotificationContext"
import { ThemeProvider } from "./utils/ThemeContext" // Importamos el ThemeProvider
import ReactGA from 'react-ga4';
import AnalyticsTracker from "./routes/AnalyticsTracker";
import AdSenseLoader from "./components/Ads/AdSenseLoader";

function App() {
    const [isLoading, setIsLoading] = useState(true)
    const handleIntroComplete = () => setIsLoading(false)

    useEffect(() => {
        ReactGA.initialize(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID);
    }, []);

    return (
        <ErrorBoundary>
            <HelmetProvider>
                <Router>
                    <AnalyticsTracker />
                    <ThemeProvider>
                        <AuthProvider>
                            <LocationProvider>
                                <CategoriesProvider>
                                    <NotificationProvider>
                                        <AppContent isLoading={isLoading} onIntroComplete={handleIntroComplete} />
                                    </NotificationProvider>
                                </CategoriesProvider>
                            </LocationProvider>
                        </AuthProvider>
                    </ThemeProvider>
                </Router>
            </HelmetProvider>
        </ErrorBoundary>
    )
}

// Componente para renderizar contenido que usa useLocation (dentro de <Router>)
function AppContent({ isLoading, onIntroComplete }) {
    const location = useLocation()
    const pathname = location.pathname;
    // Mostrar botón de WhatsApp solo en Home (/) y en la página de Categorías (/categorias/:type)
    const showWhatsappButton = pathname === '/' || pathname.startsWith('/categorias/')

    // Habilitar AdSense solo si no estamos en rutas sensibles (registro/ediciones)
    const disableAds = location.pathname.startsWith('/registro') || location.pathname.endsWith('/editar') || location.pathname.includes('/usuario/editar') || location.pathname.includes('/panel')
    const enableAds = !disableAds

    return (
        <>
            <AdSenseLoader enable={enableAds} />
            <ToastContainer />
            {isLoading ? (
                <AnimatedIntro onComplete={onIntroComplete} />
            ) : (
                <>
                    <NavBar />
                    <AppRoutes />
                    {showWhatsappButton && <WhatsAppButton />}
                    <Footer />
                </>
            )}
        </>
    )
}

export default App
